import React, { useContext } from "react";
import {
    useFloating,
    useDismiss,
    useRole,
    useClick,
    useInteractions,
    FloatingFocusManager,
    FloatingOverlay,
    FloatingPortal,
} from "@floating-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icons } from "assets/icons";
import { Config } from "config";
import { MyDNVContext } from "mydnv/context/mydnv-context";

const RapMyDNVModal = (props) => {
    const { RAPGuestURL, RAPMyDnvURL } = props;

    const { refs, context } = useFloating({
        open: props.isOpen,
        onOpenChange: props.setModalOpen,
    });
    const click = useClick(context);
    const role = useRole(context);
    const dismiss = useDismiss(context, { outsidePressEvent: "mousedown" });
    const { getFloatingProps } = useInteractions([click, role, dismiss]);
    const { InteractionStatusNone, isAuthenticated, instance, inProgress } = useContext(MyDNVContext);

    const SignInRequest = Config.MyDNV.loginRequest;
    const SignUpRequest = Config.MyDNV.signUpRequest;

    const login = (request) => {
        
        // debug(webpage, model, error);
        if (!isAuthenticated && inProgress === InteractionStatusNone) {
            // log session storage
            localStorage.setItem("signin-redirect-action", "RAP");
            
            instance.loginRedirect(request).catch((e) => {
                console.log(e);
            });
        }
    };

    return (
        <>
            <FloatingPortal>
                {props.isOpen && (
                    <FloatingOverlay className="modal-overlay" lockScroll>
                        <FloatingFocusManager context={context}>
                            <div className="modal rap-modal" ref={refs.setFloating} {...getFloatingProps()}>
                                <div className="close-btn-wrapper">
                                    <button onClick={() => props.setModalOpen(false)} className="modal-close">
                                        <FontAwesomeIcon icon={icons.solid.faXmark} />
                                    </button>
                                </div>
                                <h2>Report a problem</h2>
                                {isAuthenticated && (
                                    <>
                                        <p>
                                            This report is linked to your MyDNV account, allowing you to review your report, access your report history, and receive updates.
                                        </p>
                                        <p>If you prefer, you can <a href={RAPGuestURL}>continue as a guest.</a></p>
                                    
                                    <div className="button-wrapper">
                                        <a href={RAPMyDnvURL}><button className="btn">Ok, got it</button></a>
                                    </div>
                                    </>

                                )}
                                {!isAuthenticated && (
                                    <>
                                        <p>
                                            For the full experience, sign in with your MyDNV account to review your
                                            report, access your report history, and receive updates.
                                        </p>
                                        <p>Don’t have an account? Sign up to get the full MyDNV experience!</p>
                                        <div className="button-wrapper signin">
                                            <button className="btn" onClick={() => login(SignUpRequest)}>
                                                Sign up
                                            </button>
                                            <span>or</span>
                                            <button className="btn outline" onClick={() => login(SignInRequest)}>
                                                Log in
                                            </button>
                                        </div>
                                        <div style={{marginTop: "32px"}}>If you prefer, you can <a href={RAPGuestURL}>continue as a guest.</a></div>
                                    </>
                                )}
                            </div>
                        </FloatingFocusManager>
                    </FloatingOverlay>
                )}
            </FloatingPortal>
        </>
    );
};

export { RapMyDNVModal };
